import { getToken, getUser } from "../../../utility/Common";

const token = getToken();
const userData = getUser();

export const login = (
  state = {
    userRole: token && userData ? userData?.role_dof : "",
    fullName: token && userData ? userData?.full_name : "",
    userName: token && userData ? userData?.username : "",
  },
  action
) => {
  switch (action.type) {
    case "HANDLE_LOGIN": {
      return { ...state, values: action.payload };
    }
    case "HANDLE_LOGOUT": {
      return { ...state, values: action.payload };
    }
    case "CHANGE_ROLE": {
      return { ...state, userRole: action.userRole };
    }
    case "FILL_USER_DATA": {
      return {
        ...state,
        userRole: action?.userRole,
        fullName: action?.fullName,
        userName: action?.userName,
      };
    }
    default: {
      return state;
    }
  }
};
